import { combineReducers } from '@reduxjs/toolkit';

import userSlice from './slices/user.slice';
import reportsSlice from './slices/reports.slice';
import messagesSlice from './slices/messages.slice';
import managementSlice from './slices/management.slice';
import configurationSlice from './slices/configuration.slice';
import notificationsSlice from './slices/notifications.slice';

const appReducer = combineReducers({
  user: userSlice,
  management: managementSlice,
  configuration: configurationSlice,
  reports: reportsSlice,
  notifications: notificationsSlice,
  messages: messagesSlice,
});

const rootReducer = (state, action) => appReducer(state, action);

export default rootReducer;
